import { useApiClient } from "../../../hooks/useApiClient";
import { useSearchParams } from "react-router-dom";
import useSWR from "swr";
import { type CommercialBookStatusResponse } from "../types";

interface UseCommercialBookStatus {
  data: CommercialBookStatusResponse | undefined;
}

export const useCommercialBookStatus = (
  id: string | undefined
): UseCommercialBookStatus => {
  const { apiClient } = useApiClient();
  const [params] = useSearchParams();
  const sharedView = params.get("stored") === "1";

  const fetcher = async (
    url: string
  ): Promise<CommercialBookStatusResponse> => {
    const { data } = await apiClient.get<CommercialBookStatusResponse>(url);
    return data;
  };
  const { data } = useSWR<CommercialBookStatusResponse>(
    id === undefined
      ? null
      : sharedView
      ? `/commercial-picture-request/stored-requests/${id}/`
      : `/commercial-picture-request/${id}`,
    fetcher,
    {
      revalidateOnFocus: true,
      refreshInterval: 1000 * 30,
    }
  );

  return {
    data,
  };
};
